// The home page's notice (components/homeNotice.ts) drawn as a toast with its
// Undo, on the page whose tiles can go or join a playlist.

import { useEffect } from 'react';
import { Toast } from './Toast';
import { dismissHomeNotice, useHomeNotice } from './homeNotice';

/** How long the notice stays: long enough to reach for Undo. */
const NOTICE_MS = 6000;

export function HomeNoticeToast() {
  const notice = useHomeNotice();
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => dismissHomeNotice(notice.id), NOTICE_MS);
    return () => window.clearTimeout(timer);
  }, [notice]);
  // Leaving the page takes the notice with it.
  useEffect(() => () => dismissHomeNotice(), []);
  if (!notice) return null;
  return (
    <Toast
      testId="home-notice"
      action={{
        label: 'Undo',
        testId: 'home-notice-undo',
        onClick: () => {
          notice.undo();
          dismissHomeNotice(notice.id);
        },
      }}
    >
      {notice.text}
    </Toast>
  );
}
